(() => {
  "use strict";
  document.querySelectorAll("[data-mix-builder]").forEach((form) => {
    const dock = form.querySelector("[data-mix-bottom-dock]");
    const space = form.querySelector("[data-mix-dock-space]");
    if (!dock || !space) return;
    const toggle = dock.querySelector("[data-mix-dock-toggle]");
    const contents = [...dock.querySelectorAll("[data-mix-dock-content]")];
    const openLabel = dock.querySelector(".mix-bottom-dock-open-label");
    const toggleLabel = dock.querySelector("[data-mix-dock-toggle-label]");
    const toggleIcon = dock.querySelector("[data-mix-dock-toggle-icon]");
    document.body.classList.add("has-mix-bottom-dock");
    let pending = false;
    const update = () => {
      pending = false;
      const viewportHeight = window.visualViewport?.height || window.innerHeight;
      const viewportTop = window.visualViewport?.offsetTop || 0;
      const viewportBottom = viewportTop + viewportHeight;
      const keyboardBottom = Math.max(0, window.innerHeight - viewportBottom);
      let previewBottom = 0;
      document.querySelectorAll("#preview-bar-iframe, #admin-bar-iframe, #ShopifyPreviewBar").forEach((bar) => {
        const rect = bar.getBoundingClientRect();
        if (rect.height > 0 && rect.top > viewportBottom / 2 && rect.top < viewportBottom && rect.bottom >= viewportBottom - 2) {
          previewBottom = Math.max(previewBottom, viewportBottom - rect.top);
        }
      });
      dock.style.setProperty("--mix-dock-bottom", `${keyboardBottom + previewBottom}px`);
      dock.style.setProperty("--mix-dock-visible-height", `${viewportHeight}px`);
      dock.classList.add("is-docked");
      space.classList.add("has-docked-picker");
      const height = dock.getBoundingClientRect().height;
      document.body.style.setProperty("--mix-fixed-dock-height", `${height + previewBottom}px`);
    };
    const schedule = () => {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(update);
    };
    const setMinimized = (minimized) => {
      if (!toggle || !contents.length || !openLabel) return;
      const currentlyMinimized = toggle.getAttribute("aria-expanded") !== "true";
      if (currentlyMinimized === minimized) return;
      dock.classList.toggle("is-minimized", minimized);
      contents.forEach(content => { content.hidden = minimized; });
      openLabel.hidden = minimized;
      toggle.setAttribute("aria-expanded", String(!minimized));
      toggle.setAttribute("aria-label", minimized ? "Expand Pick A Mix panel" : "Minimise Pick A Mix panel");
      if (toggleLabel) toggleLabel.textContent = minimized ? "Expand" : "Minimise";
      if (toggleIcon) toggleIcon.textContent = minimized ? "↑" : "↓";
      schedule();
    };
    if (toggle && contents.length && openLabel) {
      toggle.addEventListener("click", () => {
        setMinimized(toggle.getAttribute("aria-expanded") === "true");
      });
      toggle.disabled = false;
    }
    let lastScrollY = window.scrollY || 0;
    let scrollDownIntentUntil = 0;
    let scrollUpIntentUntil = 0;
    let touchStartY = null;
    const markScrollIntent = (direction) => {
      const intentUntil = Date.now() + 900;
      scrollDownIntentUntil = direction === "down" ? intentUntil : 0;
      scrollUpIntentUntil = direction === "up" ? intentUntil : 0;
    };
    window.addEventListener("wheel", (event) => {
      if (event.deltaY > 0) markScrollIntent("down");
      else if (event.deltaY < 0) markScrollIntent("up");
    }, { passive: true });
    window.addEventListener("touchstart", (event) => {
      touchStartY = event.touches?.[0]?.clientY ?? null;
    }, { passive: true });
    window.addEventListener("touchmove", (event) => {
      const touchY = event.touches?.[0]?.clientY;
      if (touchStartY !== null && touchY !== undefined) {
        const fingerMovement = touchStartY - touchY;
        if (fingerMovement > 10) markScrollIntent("down");
        else if (fingerMovement < -10) markScrollIntent("up");
      }
    }, { passive: true });
    const clearTouchStart = () => { touchStartY = null; };
    window.addEventListener("touchend", clearTouchStart, { passive: true });
    window.addEventListener("touchcancel", clearTouchStart, { passive: true });
    window.addEventListener("scroll", () => {
      const scrollY = window.scrollY || 0;
      const scrollDelta = scrollY - lastScrollY;
      const scrolledDown = scrollDelta > 10;
      const scrolledUp = scrollDelta < -10;
      lastScrollY = scrollY;
      if (scrolledDown && Date.now() <= scrollDownIntentUntil) {
        scrollDownIntentUntil = 0;
        if (toggle?.getAttribute("aria-expanded") === "true") setMinimized(true);
      } else if (scrolledUp && Date.now() <= scrollUpIntentUntil) {
        scrollUpIntentUntil = 0;
        if (toggle?.getAttribute("aria-expanded") === "false") setMinimized(false);
      }
      schedule();
    }, { passive: true });
    window.addEventListener("resize", schedule, { passive: true });
    window.visualViewport?.addEventListener("resize", schedule);
    window.visualViewport?.addEventListener("scroll", schedule);
    if (typeof ResizeObserver === "function") new ResizeObserver(schedule).observe(dock);
    update();
  });
})();
